import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Landing from './components/Landing';
import Header from './components/Header';

const App = props => {
  App.propTypes = {
    auth: PropTypes.object,
  };

  const src =
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyDEj2ZFdJwei_ATNfsoUtkmCfvauoPKgDE&libraries=places';
  useEffect(() => {
    const script = document.createElement('script');

    script.src = src;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      // document.body.removeChild(script);
    };
  }, []);

  return (
    <Router>
      <div className="app">
        <div className="screen">
          <Header />
          <Switch>
            <Route path="/" render={() => <Landing auth={props.auth.auth} />} />
          </Switch>
        </div>
      </div>
    </Router>
  );
};

export default App;
